import { transformUserToManager } from '@/features/user-management/functions/mappers/mapToManager';
import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { User, UsersApiResponse } from '@/types/site';
import { useSuspenseQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

export const useUsersQuery = () => {
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.users.getList],
    queryFn: async (): Promise<User[]> => {
      const response = await XHRAuthorizedClient.get<UsersApiResponse>(
        ENDPOINTS.users.list
      );
      return response.data.data.map(transformUserToManager);
    },
  });
};
